import CartEmptyItemNew from './CartEmptyItemNew'

export default CartEmptyItemNew
